import React, { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import addBooks from "../redux/addBooks/thunk/addBooks";
import editBooks from "../redux/addBooks/thunk/editBooks";

export default function Form({ editMode, onEdit, handleCancel }) {
  const bookNameRef = useRef();
  const authorRef = useRef();
  const thumbnailRef = useRef();
  const pricRef = useRef();
  const ratingRef = useRef();
  const featuredRef = useRef();

  const dispatch = useDispatch();

  const clearForm = () => {
    bookNameRef.current.value = "";
    authorRef.current.value = "";
    thumbnailRef.current.value = "";
    pricRef.current.value = "";
    ratingRef.current.value = "";
    featuredRef.current.checked = false;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const name = bookNameRef.current.value;
    const author = authorRef.current.value;
    const thumbnail = thumbnailRef.current.value;
    const price = pricRef.current.value;
    const rating = ratingRef.current.value;
    const featured = featuredRef.current.checked;

    if (editMode) {
      dispatch(
        editBooks(onEdit.id, name, author, thumbnail, price, rating, featured)
      );
      clearForm();
      handleCancel();
    } else {
      dispatch(addBooks(name, author, thumbnail, price, rating, featured));
      clearForm();
    }
  };
  const cancelEdit = () => {
    clearForm();
    handleCancel();
  };

  useEffect(() => {
    if (editMode) {
      bookNameRef.current.value = onEdit.name;
      authorRef.current.value = onEdit.author;
      thumbnailRef.current.value = onEdit.thumbnail;
      pricRef.current.value = onEdit.price;
      ratingRef.current.value = onEdit.rating;
      featuredRef.current.checked = onEdit.featured;
    }
  }, [editMode, onEdit]);

  return (
    <form className="book-form" onSubmit={(e) => handleSubmit(e)}>
      <div className="space-y-2">
        <label htmlFor="name">Book Name</label>
        <input
          ref={bookNameRef}
          required
          className="text-input"
          type="text"
          id="input-Bookname"
          name="name"
        />
      </div>

      <div className="space-y-2">
        <label htmlFor="category">Author</label>
        <input
          ref={authorRef}
          required
          className="text-input"
          type="text"
          id="input-Bookauthor"
          name="author"
        />
      </div>

      <div className="space-y-2">
        <label htmlFor="image">Image Url</label>
        <input
          ref={thumbnailRef}
          required
          className="text-input"
          type="text"
          id="input-Bookthumbnail"
          name="thumbnail"
        />
      </div>

      <div className="grid grid-cols-2 gap-8 pb-4">
        <div className="space-y-2">
          <label htmlFor="price">Price</label>
          <input
            ref={pricRef}
            required
            className="text-input"
            type="number"
            id="input-Bookprice"
            name="price"
          />
        </div>

        <div className="space-y-2">
          <label htmlFor="quantity">Rating</label>
          <input
            ref={ratingRef}
            required
            className="text-input"
            type="number"
            id="input-Bookrating"
            name="rating"
            min="1"
            max="5"
          />
        </div>
      </div>

      <div className="flex items-center">
        <input
          ref={featuredRef}
          id="input-Bookfeatured"
          type="checkbox"
          name="featured"
          className="w-4 h-4"
        />
        <label htmlFor="input-Bookfeatured" className="ml-2 text-sm">
          This is a featured book
        </label>
      </div>

      <button type="submit" className="submit" id="submit">
        {editMode ? "Update book" : "Add Book"}
      </button>
      {editMode && (
        <button className="cancel" id="cancel" onClick={cancelEdit}>
          Cancel edit
        </button>
      )}
    </form>
  );
}
